import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';
import { EdlItemPacketStatusQuery } from '../model/enum/item-packet/edl-item-packet-status-query.enum';

export const ItemPacketLazyLoadedStates= new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    list: LazyLoadedStates,
    details: LazyLoadedStates,
    create: LazyLoadedStates,
    edit: LazyLoadedStates

}> ({
    base: {
        name: 'authenticated.administration.item-packet',
        url: '/item-packet',
        abstract: true,
    }, 
    list: {
        name: 'authenticated.administration.item-packet.list',
        url: '/packets/:page?limit&searchBy&orderBy&ascending&status',
        params: {
            page: {
                raw: true,
                type: 'int',
                value: 1
            },
            limit: {
                raw: true,
                type: 'int',
                value: 20
            },
            searchBy: {
                raw: true,
                type: 'string',
                value: '',
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            },
            status: {
                raw: true,
                type: 'int',
                value: EdlItemPacketStatusQuery.ACTIVE
            }
        }
    }, 
    details: {
        name: 'authenticated.administration.item-packet.details',
        url: '/details',
        abstract: true
    }, 
    create: {
        name: 'authenticated.administration.item-packet.details.create',
        url: '/create'
    }, 
    edit: {
        name: 'authenticated.administration.item-packet.details.edit',
        url: '/edit/:itemPacketId'
    }
},
() => import('src/app/item-packets/pages/item-packets.module').then((result: {ItemPacketsModule: any}) => result.ItemPacketsModule)
);
